import { auth } from '@/firebase/index.js'
import store from '@/store'

async function pollForEmailVerified () {
  await auth().currentUser.reload()
  var user = auth().currentUser
  if (user && !user.emailVerified) {
    setTimeout(pollForEmailVerified, 3000)
  } else if (user) {
    store.dispatch('auth/storeAuthenticatedUser', { authUser: user })
  } else {
    store.commit('auth/noLocalUser')
  }
}

// Initial check if a user has been stored locally
auth().onAuthStateChanged(user => {
  if (user) {
    store.dispatch('auth/storeAuthenticatedUser', { authUser: user })
    if (!user.emailVerified) pollForEmailVerified()
  } else {
    store.commit('auth/noLocalUser')
  }
})
